import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['expandable', 'button'];
  static values = { id: String };

  connect() {
    if (this.onPrint) return;

    this.element.style.opacity = 0;

    setTimeout(() => {
      this.restoreState();
      this.update();

      this.buttonTarget.classList.add('transition-transform', 'duration-200');
      this.expandableTarget.classList.add(
        'transition-height',
        'duration-200',
        'inline-block',
        'w-full',
      );

      this.expandableTarget.classList.add('transition-height', 'duration-200');

      if (this.isOpen) this.expandableTarget.style.overflow = null;
      else this.expandableTarget.style.overflow = 'hidden';

      this.expandableTarget.addEventListener(
        'transitionend',
        this.transitionEnd.bind(this),
      );

      this.element.style.opacity = 100;
    }, 200);
  }

  disconnect() {
    if (this.onPrint) return;

    this.expandableTarget.removeEventListener(
      'transitionend',
      this.transitionEnd.bind(this),
    );
  }

  transitionEnd() {
    if (this.isOpen) this.expandableTarget.style.overflow = null;
  }

  toggle(event) {
    if (event) event.preventDefault();

    this.buttonTarget.classList.toggle('open');
    this.update();
    this.saveState();
  }

  update() {
    this.expandableTarget.style.overflow = 'hidden';
    if (this.isOpen) {
      this.buttonTarget.style.transform = 'rotate(180deg)';
      this.expandableTarget.style.height = `${this.expandableTarget.scrollHeight}px`;
    } else {
      this.buttonTarget.style.transform = 'rotate(0deg)';
      this.expandableTarget.style.height = '0';
    }
  }

  saveState() {
    if (!this.idValue) return;

    const state = this.isOpen ? 'open' : 'closed';
    localStorage.setItem('toggle.' + this.idValue, state);
  }

  restoreState() {
    if (!this.idValue) return;

    const state = localStorage.getItem('toggle.' + this.idValue);
    if (!state) return;

    if ((state === 'open') !== this.isOpen) this.toggle();
  }

  get isOpen() {
    return this.onPrint || this.buttonTarget.classList.contains('open');
  }

  get onPrint() {
    return document
      .getElementsByTagName('body')[0]
      .classList.contains('js-print');
  }
}
